import * as Factory from "factory";
export const timeStamps = Factory.Sync.makeFactory({
    createdAt: Factory.Sync.each(()=>new Date()),
    updatedAt: Factory.Sync.each(()=>new Date())
});
export const absoluteURL = (path)=>{
    if (process.env.GITPOD_WORKSPACE_URL) {
        const prefix = `https://${process.env.PORT || `3000`}-${process.env.GITPOD_WORKSPACE_URL.slice(8)}`;
        return prefix + path;
    } else if (process.env.HEROKU_APP_NAME) {
        const prefix = `https://${process.env.HEROKU_APP_NAME}.herokuapp.com`;
        return prefix + path;
    }
    return `http://localhost:${process.env.PORT || `3000`}` + path;
};
